// extracted by mini-css-extract-plugin
export var backgroundImage = "intro-module--backgroundImage--3gV0h";
export var headline = "intro-module--headline--1L8HI";
export var cards = "intro-module--cards--2PaUk";
export var card = "intro-module--card--1E7ap";
export var cardTitle = "intro-module--cardTitle--DsO6S";
export var cardCopy = "intro-module--cardCopy--RfjbC";